<template>
  <div>
    <menu-component></menu-component>
    <section class="banner_area banner_area_5">
    </section>
    <v-quotation-sectionfrom></v-quotation-sectionfrom>
  </div>
</template>

<script>
import Quotation_sectionfrom from "./QuotationSection.vue";
export default {
  name: "Quotation",
  components: {
    "v-quotation-sectionfrom": Quotation_sectionfrom
  },

};
</script>

<style lang="scss">
.bg-menu {
  background: #55988D !important;
  box-shadow: 5px 5px 40px;
  /* Sombra con un desenfoque casi disipado */
}

@media (max-width: 600px) {
  .step-progress__bar {
    height: 50px;
  }

  .bg-menu {
    background: transparent !important;
    box-shadow: 0px 0px 0px;
    /* Sombra con un desenfoque casi disipado */
  }

  .header_menu {
    box-shadow: 10px 10px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/GrayZone/Quotation.vue